import { useLanguage } from "@/i18n/LanguageContext";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

export const LanguageSwitcher = ({ variant = "icon" }: { variant?: "icon" | "text" }) => {
  const { language, switchLanguage } = useLanguage();

  const toggleLanguage = () => {
    switchLanguage(language === "it" ? "en" : "it");
  };

  if (variant === "text") {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleLanguage}
        className="text-muted-foreground hover:text-foreground gap-2"
      >
        <Globe className="w-4 h-4" />
        {language === "it" ? "EN" : "IT"}
      </Button>
    );
  }

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-muted hover:bg-muted/80 transition-colors text-sm font-medium"
    >
      <Globe className="w-4 h-4" />
      {language.toUpperCase()}
    </button>
  );
};
